import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';


import { BsModalComponent, BsModalBodyComponent, BsModalService } from 'ng2-bs3-modal';
import 'jquery'
import 'bootstrap'

//import { Lists_cmmt } from '../../../routes/menu'


const swal = require('sweetalert');
@Component({
  selector: 'app-daotao-chotsobuoihocedit',
  templateUrl: './chotsobuoihocedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./chotsobuoihocedit.component.scss'],
    providers: [ListService, Repository]
})


export class chotsobuoihoceditComponent implements OnInit {
  doanhnghiepid: string = null;
  public ngaysinh: Date = null;
  public ngaycmnd: Date = null;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any;
  inputhangbaohiems: any;
  inputphongbans: any;
  inputhangxes: any;
  inputkhachhangs: any;
  inputmausacs: any;
  inputmodels: any;
  inputnhomctmts: any;
  indLoading: boolean = false;
  totalItems: number = 0;
  dslops: any;
  doituongSelect: any = {
    Id: null, NhanSuId: null, LyDo: null, SoBuoi: null, LopId: null
    , NgayNhap: null, TrangThai: null, GhiChu: null
    ,Created: null, Modified: null, CreatedBy: null, ModifiedBy: null

  };       
    nhomdtid:string=null;
  hoatdong: string = null;
  inputnhacungcaps: any = [
    { Ten_Doi_Tuong: "Cá nhân", Ma_Doi_Tuong: '0', Id: false },
    { Ten_Doi_Tuong: "Tổ chức", Ma_Doi_Tuong: '1', Id: true },
  ];

  dstrangthais: any = [
    { Ten: 'Nghỉ học', Id: 0 },
    { Ten: 'Học bình thường', Id: 1 },
    { Ten: 'Bảo lưu', Id: 2 }
    
  ];

  inputthus: any = [
    { Ten: 'Thứ 2', Id: 2 },
    { Ten: 'Thứ 3', Id: 3 },
    { Ten: 'Thứ 4', Id: 4 },
    { Ten: 'Thứ 5', Id: 5 },
    { Ten: 'Thứ 6', Id: 6 },
    { Ten: 'Thứ 7', Id: 7 },
    { Ten: 'Chủ nhật', Id: 8 }
  ];

  inputgioitinhs: any = [
    { Ten_Doi_Tuong: "Nữ", Ma_Doi_Tuong: '0', Id: false },
    { Ten_Doi_Tuong: "Nam", Ma_Doi_Tuong: '1', Id: true },
  ];

  inputloais: any = [
    { text: "Nhân công", value: 0 },
    { text: "Vật tư sơn", value: 1 },
  ];

  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @Output() save: EventEmitter<any> = new EventEmitter();

  Password: string = null;
  PasswordNew: string = null;
  PasswordConfirm: string = null;
  username: string = null;
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };

    constructor( private _dataService: ListService, public repo: Repository) {
       
        
    }

    ngOnInit(): void {
       
    }

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
    }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  bnhomctmt: boolean = false;
  currentUser: any;
  tieudectmt: any;
  tieudectmtplace: any;
  hosoid: string;
  TaiKhoan: string;
  datas: any;
 
  loadDataInit(nhomdoituongid: string, id: string, donviid: string, rowdata: any, hocvienid: string) {

    this.doituongSelect = {
      Id: null, NhanSuId: null, LyDo: null, SoBuoi: null, LopId: null
      , NgayNhap: null, TrangThai: null, GhiChu: null
      , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
    };

   


    this.hosoid = hocvienid;
    //this.hosoid = lopid;
    this.doituongSelect.NhanSuId = hocvienid;
          var authlogin = localStorage.getItem('currentUser');
          if (authlogin) {

            this.currentUser = JSON.parse(authlogin);
            this.username = this.currentUser.user_name;
            this.doituongSelect.Created = new Date();
            this.doituongSelect.CreatedBy = this.currentUser.user_name;
            this.doituongSelect.Modified = new Date();
            this.doituongSelect.ModifiedBy = this.currentUser.user_name;

    }

    this.repo.postRequest('api/hoso/combolophoc', { UserName: this.currentUser.user_name, DonViId: this.currentUser.id_don_vi })
      .subscribe(response => {
        this.dslops = response;
      });

    this.loaddatas();
     


  }
  getbyid() {
    this.repo.postRequest("api/Login/chotsobuoihocbyid/", this.doituongSelect)
      .subscribe(response => {
        if (response != null) {
          this.doituongSelect.Created = new Date(response.Created);
          this.doituongSelect.CreatedBy = response.CreatedBy;
          this.doituongSelect.SoBuoi = response.SoBuoi;
          this.doituongSelect.GhiChu = response.GhiChu;
          this.doituongSelect.Id = response.Id;
          this.doituongSelect.NhanSuId = response.NhanSuId;
          this.doituongSelect.LopId = response.LopId;
          this.doituongSelect.Modified = new Date();
          this.doituongSelect.ModifiedBy = this.currentUser.user_name;
        }

      });
  }
   
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
    public closeModal(){
        this.save.emit(null);
  }

  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }
  ThucHien() {
    this.doituongSelect.NhanSuId = this.hosoid;
    if (this.doituongSelect.Created == null) {
      swal('Lỗi!', "Vui lòng nhập ngày tạo.", 'error');
      return;
    }
    if (this.doituongSelect.SoBuoi == null) {
      swal('Lỗi!', "Vui lòng nhập số buổi.", 'error');
      return;
    }
    
    this.repo.postRequest("api/Login/chotsobuoihoc/", this.doituongSelect
    )
      .subscribe(response => {
        if (response != null && response.match('OK_')) {
          swal('Saved!', 'Lưu thành công!.', 'success');
          this.doituongSelect.Id = response.Id;
          this.loaddatas();
         // this.save.emit(this.doituongSelect);
        }
        else if (response != null) {
          swal('Lỗi!', response, 'error');
        }

        console.log(response);

      });
  }

  XoaChotBuoiHoc() {

   
    this.repo.postRequest("api/Login/xoachotsobuoihocbyid/", this.doituongSelect
    )
      .subscribe(response => {
        if (response != null && response.match('OK')) {
          //swal('Saved!', 'Lưu thành công!.', 'success');
          //this.save.emit(this.doituongSelect);
          this.loaddatas();
        }
        else if (response != null) {
          swal('Lỗi!', response, 'error');
        }

        console.log(response);

      });
  }

  deleterow(index: string) {
    //console.log(index);
    swal({
      title: 'Bạn muốn xóa dòng này phải không?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          this.repo.postRequest("api/Login/xoachotsobuoihocbyid/", {  NhanSuId: this.datas[index].NhanSuId, LopId: this.datas[index].LopId }
          )
            .subscribe(response => {
              if (response != null && response.match('OK')) {
                this.loaddatas();
              }
              else if (response != null) {
                swal('Lỗi!', response, 'error');
              }

              console.log(response);

            });
          this.datas.splice(index, 1);
        }
      });


  }
   
  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }
  indexdt: number;
  cotdt: string;


  loaddatas() {
    this.repo.postRequest("api/Login/getchotsobuoihoc/", { NhanSuId: this.hosoid }
    )
      .subscribe(response => {
        if (response != null) {
          this.datas = response;
          this.totalItems = this.datas.length;
        }
        

      });
  }
  tId: any = null;
  selectedRow: any;
  selected(row: any) {
    this.tId = row.Id;
    this.selectedRow = row;
    this.doituongSelect = {
      Id: null, NhanSuId: null, LyDo: null, SoBuoi: null, LopId: null
      , NgayNhap: null, TrangThai: null, GhiChu: null
      , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
    };
    this.doituongSelect = row;
    this.doituongSelect.Modified = new Date();
    this.doituongSelect.ModifiedBy = this.currentUser.user_name;
  }

  LamMoi() {
    this.doituongSelect = {
      Id: null, NhanSuId: null, LyDo: null, SoBuoi: null, LopId: null
      , NgayNhap: null, TrangThai: null, GhiChu: null
      , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
    };
    this.tId = null;
    this.selectedRow = null;
    this.doituongSelect.Created = new Date();
    this.doituongSelect.CreatedBy = this.currentUser.user_name;
    this.doituongSelect.Modified = new Date();
    this.doituongSelect.ModifiedBy = this.currentUser.user_name;
  }

   


}
